module.exports = {
	'constant-position': require('./constant-position.js'),
	'constant-speed': require('./constant-speed.js'),
	'constant-acceleration': require('./constant-acceleration.js'),
	composition: require('./composition.js'),
	'constant-position-with-null': require('./constant-position-with-null.js'),
	'constant-speed-with-null': require('./constant-speed-with-null.js'),
	'constant-speed-dynamic': require('./constant-speed-dynamic.js'),
	'shortterm-constant-speed': require('./shortterm-constant-speed.js'),
};
